import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { Input, Button, message } from "antd";
import "./Login.css";
import NewLogo from "../../assets/images/logonew.jpg";

const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpRequested, setOtpRequested] = useState(false);
  const [profileType, setProfileType] = useState("user");

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const emailFromQuery = params.get("email");
  const selectedPlan = params.get("plan");
  const roleFromQuery = params.get("role");

  useEffect(() => {
    if (roleFromQuery === "vendor") {
      setProfileType("vendor");
    } else {
      setProfileType("user");
    }
  }, [roleFromQuery]);

  // Auto-fill email from query param
  useEffect(() => {
    if (emailFromQuery) {
      setEmail(emailFromQuery);
    }
  }, [emailFromQuery]);

  // 🚀 If already signed in, redirect to plans with query
  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token && selectedPlan) {
      navigate(`/plans?plan=${selectedPlan}`);
    }
  }, [navigate, selectedPlan]);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/v1/signup`,
        { email, name, profileType },
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data;
      if (data.success) {
        setOtpRequested(true);
        message.success(data.message || "OTP sent successfully");
      } else {
        message.error(data.message || "Failed to send OTP. Please try again.");
      }
    } catch (error) {
      const backendMessage =
        error.response?.data?.message || "An error occurred. Please try again.";
      message.error(backendMessage);
      console.log(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = JSON.stringify({ email, otp });
      const otpResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/v1/verifyotp`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      const otpData = otpResponse.data;
      if (otpData.status) {
        localStorage.setItem("userToken", otpData.userToken);

        if (selectedPlan) {
          navigate(`/plans?plan=${selectedPlan}`);
        } else {
          navigate("/plans");
        }
      } else {
        message.error("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="container center">
        <div className="new-login-page">
          <div className="right-content">
            <img loading="lazy" src={NewLogo} alt="collings-denture" />
          </div>

          <div className="left-content">
            {/* The same two doors the sign-in card offers. Sign-in had this
                toggle and signup did not, so someone who came here to
                register a laboratory had no way across - and the marketing
                site now sends people to a vendor signup by name.

                Vendor goes to /vendors?mode=signup rather than bare
                /vendors: this is the registration card, so the vendor
                equivalent is vendor registration, not vendor sign-in. */}
            <div className="auth-toggle" role="tablist" aria-label="Account type">
              <button
                type="button"
                role="tab"
                aria-selected="true"
                className="auth-toggle-option auth-toggle-active"
              >
                User
              </button>
              <button
                type="button"
                role="tab"
                aria-selected="false"
                className="auth-toggle-option"
                onClick={() => navigate("/vendors?mode=signup")}
              >
                Vendor
              </button>
            </div>

            <h2>Sign up with Email</h2>
            <p>Create your account to explore.</p>
            <form onSubmit={otpRequested ? handleVerifyOtp : handleSendOtp}>
              <div className="input-group">
                <Input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  disabled={otpRequested}
                  placeholder="Enter your name"
                />
              </div>
              <div className="input-group">
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={otpRequested}
                  placeholder="Enter your email"
                />
              </div>

              {otpRequested && (
                <>
                  <div className="input-group">
                    <Input
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      required
                      placeholder="Enter 6 digit OTP"
                    />
                  </div>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    {loading ? "Verifying..." : "Verify OTP"}
                  </Button>
                </>
              )}

              {!otpRequested && (
                <Button type="primary" htmlType="submit" loading={loading}>
                  {loading ? "Sending OTP..." : "Get Started"}
                </Button>
              )}
            </form>
            <div className="auth-alt">
              Have an Account ?{" "}
              <Link to="/">
                Sign in
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
